import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const PROCESS_TASK_CREATORS_QUERY = gql`
  query ProcessTasksCreatorsQuery($processTaskIds: [StrictString!]!)
  @skipAudit
  @engComponent(name: WORKFLOWS) {
    processTasks(ids: $processTaskIds) {
      ... on ProcessTaskNode {
        id
        name
        creator {
          id
          name
          handle
        }
        rootTask {
          id
          creator {
            id
            name
            handle
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
